import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Typography } from '@material-ui/core';
import ApplicantDataNaturalPerson from './ApplicantDataNaturalPerson';
import ApplicantDataLegalEntity from './ApplicantDataLegalEntity';

const ApplicantData = ({ voterRequiredData, voter, change, readonly }) => {
  const updateVoterType = (e, participantType) => {
    if (!readonly) {
      const voter = {
        participantType,
      };
  
      change('voter', voter);
    }
    
    e.preventDefault();
  };

  return (
    <React.Fragment>
      {voterRequiredData.naturalPersonEnabled && voterRequiredData.legalEntityEnabled
        ? <React.Fragment>
            <div className="row" style={{ justifyContent: 'center', marginTop: 16, opacity: readonly ? 0.65 : 1 }}>
              <a href="#" onClick={e => updateVoterType(e, 'naturalPerson')} className="col-sm-6 col-md-4 obszar-link">
                <div className="inner-wrapper" style={{ borderWidth: voter.participantType === 'naturalPerson' ? 2 : 0, borderStyle: 'solid', borderColor: 'black' }}>
                  <p>Osoba prywatna</p>
                  <span className="btn">Wybierz</span>
                </div>
              </a>
              <a href="#" onClick={e => updateVoterType(e, 'legalEntity')} className="col-sm-6 col-md-4 obszar-link">
                <div className="inner-wrapper" style={{ borderWidth: voter.participantType === 'legalEntity' ? 2 : 0, borderStyle: 'solid', borderColor: 'black' }}>
                  <p>Inna jednostka</p>
                  <span className="btn">Wybierz</span>
                </div>
              </a>
            </div>
        </React.Fragment> : null}
      {voter.participantType === 'naturalPerson' ? <ApplicantDataNaturalPerson voterRequiredData={voterRequiredData} readonly={readonly} /> : null}
      {voter.participantType === 'legalEntity' ? <ApplicantDataLegalEntity voterRequiredData={voterRequiredData.organizationData} readonly={readonly} /> : null}
          
      <Field
        name="voter.participantType"
        component={({ meta }) => (meta.error && meta.touched ? <Typography variant="caption" color="error" component="p" style={{ marginTop: 16 }}>{meta.error}</Typography> : null)}
      />
    </React.Fragment>
  );
};

ApplicantData.propTypes = {
  voterRequiredData: PropTypes.object.isRequired,
  voter: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  readonly: PropTypes.bool,
};

export default ApplicantData;



// WEBPACK FOOTER //
// ./src/components/budget/ApplicantData.js